// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"125":"1c2c334c","594":"c9b727a4"}[chunkId] + ".js";
};